import {
  ChecklistTemplateId,
  ChecklistTemplateResponse,
  CompactChecklistTemplateResponse,
  ChecklistStepResponse,
} from '@business/entities/checklist';

import { Endpoint } from '../endpoint';

export function fetchChecklistTemplates(fullResponse = false, allTemplates?: boolean) {
  return Endpoint.get<CompactChecklistTemplateResponse[]>('@gc/checklist-template', {
    params: { fullResponse, allTemplates: allTemplates || false },
  });
}

export function fetchChecklistTemplate(id: ChecklistTemplateId) {
  return Endpoint.get<ChecklistTemplateResponse>(`@gc/checklist-template/checklist/${id}`);
}

export function createChecklistTemplate(data: Partial<ChecklistTemplateResponse>) {
  return Endpoint.post<ChecklistTemplateResponse>(`@gc/checklist-template/create`, { data });
}

export function updateChecklistTemplate(id: ChecklistTemplateId, data: Partial<ChecklistTemplateResponse>) {
  return Endpoint.patch<ChecklistTemplateResponse>(`@gc/checklist-template/${id}`, { data });
}

export function duplicateChecklistTemplate(id: ChecklistTemplateId) {
  return Endpoint.post<ChecklistTemplateResponse>(`@gc/checklist-template/duplicate/${id}`);
}

export function deleteChecklistTemplate(id: ChecklistTemplateId) {
  return Endpoint.delete<void>(`@gc/checklist-template/${id}`);
}

export function executeChecklistTemplate(id: ChecklistTemplateId) {
  return Endpoint.post<void>(`@gc/checklist-template/execute/${id}`);
}

/** Section **/
export function createChecklistSection(id: ChecklistTemplateId, name: string) {
  return Endpoint.post<void>(`@gc/checklist-template/section/${id}`, { data: { name } });
}

export function updateChecklistSection(id: number, name: string) {
  return Endpoint.patch<void>(`@gc/checklist-template/section/${id}`, { data: { name } });
}

export function deleteChecklistSection(id: number) {
  return Endpoint.delete<void>(`@gc/checklist-template/section/${id}`);
}

export function sortSections(ids: number[]) {
  return Endpoint.post<void>(`@gc/checklist-template/sort-section`, { data: { ids } });
}
export function orderSections(id: ChecklistTemplateId, items: any[]) {
  return Endpoint.post<ChecklistTemplateResponse>(`@gc/checklist-template/order-sections/${id}`, { data: { items } });
}

/** Step **/
export function createChecklistStep(
  ChecklistTemplateId: ChecklistTemplateId,
  id: number,
  data: Partial<ChecklistStepResponse>,
  parentStepId?: number,
) {
  data = { ...data, ChecklistTemplateId, parentStepId };
  return Endpoint.post<void>(`@gc/checklist-template/step/${id}`, { data });
}

export function updateChecklistStep(id: number, data: Partial<ChecklistStepResponse>) {
  return Endpoint.patch<void>(`@gc/checklist-template/step/${id}`, { data });
}

export function deleteChecklistStep(id: number) {
  return Endpoint.delete<void>(`@gc/checklist-template/step/${id}`);
}

export function sortSectionSteps(ids: number[]) {
  return Endpoint.post<void>(`@gc/checklist-template/sort-step`, { data: { ids } });
}

export function updateAssignne(type: string, id: number | string, items: string[], assignSection?: boolean, assignStep?: boolean) {
  return Endpoint.post<ChecklistTemplateResponse>(`@gc/checklist-template/assignee`, {
    data: { type, id, items, assignSection: assignSection || false, assignStep: assignStep || false },
  });
}

export function selectUserTeam(id: string, ids: string[], keepAssignee: boolean) {
  return Endpoint.post<void>(`@gc/checklist-template/execute-assignees/${id}`, { data: { ids, keepAssignee } });
}
